export default __webpack_public_path__ + "static/media/12.48aa1e05.png";